import { CreditCard, Settings2 } from "lucide-react";

export const sideData = {
  navMain: [
    {
      title: "Transactions",
      url: "#",
      icon: CreditCard,
      isActive: true,
      items: [
        {
          title: "View Logs",
          url: "/transaction-logs",
        },
        {
          title: "Report",
          url: "/transaction-report",
        },
      ],
    },
    {
      title: "Platforms",
      url: "#",
      icon: Settings2,
      items: [
        {
          title: "Payment Channels",
          url: "/payment-channels",
        },
        {
          title: "Manage Secret Keys",
          url: "/manage-secret-keys",
        },
      ],
    },
    {
      title: "Settings",
      url: "#",
      icon: Settings2,
      items: [
        {
          title: "Currency",
          url: "/currency",
        },
        {
          title: "Exchange Rate",
          url: "/exchange-rate",
        },
        {
          title: "API Keys",
          url: "/api-keys",
        },
        {
          title: "Profile",
          url: "/profile",
        },
      ],
    },
  ],
};
